import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Observer, PropTypes as MobxPropTypes } from 'mobx-react'
import { Marker, MarkerClusterer, InfoBox, useGoogleMap } from '@react-google-maps/api'

import { buildMarkerSvgBinary, isActiveMarker } from './utils'
import { rootStoreInstance } from '../../Srp/SearchBar/stores'
import CardMapPreview from './CardMapPreview'
import { MIN_DISTANCE } from './constants'


const ListingsMarkerCluster = ({ store }) => {
  const { valueStateStore } = rootStoreInstance
  const { year, pricePeriod, order } = valueStateStore.valuesForSubmit

  const [isLoading, setLoading] = useState(false)
  const [visibleListingId, setVisibleListingId] = useState(null)
  const [hoveredListingId, setHoveredListingId] = useState(null)

  const map = useGoogleMap()

  const getListingDetailsAndMarkActive = listing => () => {
    setVisibleListingId(listing.id)
    store.getListingDetails(listing, { year, pricePeriod, order }, setLoading)
  }

  const markAsNoActive = () => {
    setVisibleListingId(null)
    store.markAsNoActive()
  }

  const handleOnSaveClick = e => {
    e.stopPropagation()
    e.preventDefault()
    store.updateSaveStatus(store.activeItem)
  }

  const onClusteringEnd = markerClusterer => {
    const allClusters = markerClusterer.getClusters()
    const clusters = allClusters.filter(cls => cls.getMarkers().length > 1)
    const zoom = map.getZoom()

    clusters.forEach(cluster => {
      cluster.getMarkers().forEach((marker, index) => {
        marker.setPosition({
          lat: marker.lat + index * MIN_DISTANCE * Math.log10(zoom),
          lng: marker.lng + index * MIN_DISTANCE * Math.log10(zoom)
        })
      })
    })
  }

  const isCardVisible = listing => listing.id === visibleListingId

  const getIconDimensions = listing => listing.shortPrice ? [42, 35] : [18, 18]

  const getAnchorPoint = listing => {
    const [width, height] = getIconDimensions(listing)
    const y = listing.shortPrice ? height : height / 2
    return [width / 2, y]
  }

  return (
    <MarkerClusterer
      defaultMaxZoom={0}
      gridSize={0}
      onClusteringEnd={onClusteringEnd}
    >
      {() => (
        store.collection.map((listing, index) => (
          <Observer key={listing.id}>
            {() => (
              <Marker
                position={{ lat: listing.lat, lng: listing.lon }}
                icon={{
                  url: buildMarkerSvgBinary({ store, listing, hovered: hoveredListingId === listing.id}),
                  scaledSize: global.google && new global.google.maps.Size(...getIconDimensions(listing)),
                  anchor: global.google && new global.google.maps.Point(...getAnchorPoint(listing))
                }}
                zIndex={
                  isActiveMarker(store, listing)
                    ? 9999
                    : listing.shortPrice
                      ? 999 + index
                      : index
                }
                onClick={getListingDetailsAndMarkActive(listing)}
                onMouseOver={() => setHoveredListingId(listing.id)}
                onMouseOut={() => setHoveredListingId(null)}
              >
                {isCardVisible(listing)
                  ? <InfoBox
                    options={{
                      boxStyle: { overflow: 'unset' },
                      infoBoxClearance: global.google && new global.google.maps.Size(10, 10),
                      closeBoxURL: '',
                      pixelOffset: global.google && new global.google.maps.Size(-150, -330),
                      enableEventPropagation: true
                    }}
                  >
                    <CardMapPreview
                      isLoading={isLoading}
                      activeItem={store.activeItem}
                      handleOnSaveClick={handleOnSaveClick}
                      removeMarkAsActive={markAsNoActive}
                    />
                  </InfoBox>
                  : null
                }
              </Marker>
            )}
          </Observer>
        ))
      )}
    </MarkerClusterer>
  )
}

ListingsMarkerCluster.propTypes = {
  store: PropTypes.shape({
    collection: MobxPropTypes.arrayOrObservableArray,
    activeItemID: PropTypes.number,
    updateSaveStatus: PropTypes.func.isRequired,
    markAsActive: PropTypes.func.isRequired,
    getListingDetails: PropTypes.func,
    markAsNoActive: PropTypes.func.isRequired,
    activeItem: PropTypes.object,
    isLoadingListing: PropTypes.bool
  }).isRequired
}

export default ListingsMarkerCluster
